import { StateEnum } from "../../../Models/Bases/StateEnum";
import { BaseService } from "../../Bases/BaseService";
import { ValidationResponse } from "../../Bases/ValidationResponse";


export class UsuarioFiltroAcessoService extends BaseService {
    public selecionarValidos(usuarioFiltroAcessos: any) {
        return usuarioFiltroAcessos?.filter((e: any) => e.state != StateEnum.Deleted) ?? [];
    }

    public salvar(usuarioFiltroAcesso: any, usuarioFiltroAcessos: any) {
        if (!this.numberIsFilled(usuarioFiltroAcesso.origem_id) &&
            !this.numberIsFilled(usuarioFiltroAcesso.destino_id) &&
            !this.numberIsFilled(usuarioFiltroAcesso.origem_id) &&
            !this.numberIsFilled(usuarioFiltroAcesso.valor_minimo) &&
            !this.numberIsFilled(usuarioFiltroAcesso.valor_maximo)) {
            return new ValidationResponse(null, 'Preencha ao menos um dos campos solicitados!');
        }

        let validation = usuarioFiltroAcessos?.filter(
            (e: any) =>
                usuarioFiltroAcesso.id != e.id &&
                usuarioFiltroAcesso.origem_id == e.origem_id &&
                usuarioFiltroAcesso.destino_id == e.destino_id &&
                usuarioFiltroAcesso.origem_id == e.origem_id &&
                usuarioFiltroAcesso.valor_minimo == e.valor_minimo &&
                usuarioFiltroAcesso.valor_maximo == e.valor_maximo &&
                e.state != StateEnum.Deleted);

        if (validation.length > 0) {
            return new ValidationResponse(null, 'Filtro já inserido!');
        }

        if (usuarioFiltroAcesso.id == 0) {
            let ids = usuarioFiltroAcessos?.map((x: any) => x.id) ?? [];
            let min = Math.min.apply(null, ids);
            usuarioFiltroAcesso.id = min > 0 ? -1 : min - 1; //isNaN(min) || 
            usuarioFiltroAcesso.state = StateEnum.Inserted;
            usuarioFiltroAcessos = usuarioFiltroAcessos.concat(usuarioFiltroAcesso);
        }
        else {
            usuarioFiltroAcesso.state = usuarioFiltroAcesso.state == StateEnum.Inserted ? StateEnum.Inserted : StateEnum.Updated;
            var index = usuarioFiltroAcessos.map(function(x:any) {return x.id; }).indexOf(usuarioFiltroAcesso.id);
            usuarioFiltroAcessos[index] = usuarioFiltroAcesso;
        }

        return new ValidationResponse(usuarioFiltroAcessos);
    }

    public apagar(id: number, usuarioFiltroAcessos: any) {
        if (id > 0) {
            usuarioFiltroAcessos.forEach((e: any) => e.state = (e.id == id ? StateEnum.Deleted : e.state));
        }
        else {
            usuarioFiltroAcessos = usuarioFiltroAcessos?.filter((e: any) => e.id != id);
        }

        return new ValidationResponse(usuarioFiltroAcessos);
    }
}